import classNames from 'classnames';
import React, { InputHTMLAttributes, Ref } from 'react';
import { FieldError } from 'react-hook-form';
import './Input.scss';
import { useTranslation } from 'react-i18next';

export interface InputProps extends InputHTMLAttributes<any> {
  inputStyle?: 'background-light' | 'background-dark' | 'bordered';
  inputSize?: 'large' | 'normal';
  textarea?: boolean;
  className?: string;
  label?: string;
  error?: FieldError;
}

const Input = React.forwardRef((props: InputProps, ref: Ref<any>) => {
  const { t } = useTranslation()

  const {
    inputStyle = 'bordered',
    inputSize = 'normal',
    textarea,
    className,
    label,
    error,
    ...restProps
  } = props;

  const inputClassNames = classNames('input-wrapper', className, {
    'input--bg-light': inputStyle === 'background-light',
    'input--bg-dark': inputStyle === 'background-dark',
    'input--bordered': inputStyle === 'bordered',
    'input--large': inputSize === 'large',
    'input--normal': inputSize === 'normal',
  });

  const getError = () => {
    if (!error) {
      return null
    }

    const msg = error.message as unknown as { key: string; extra: any };

    if (msg.key) {
      return t(`errors:form.${msg.key}`, {
        field: props.name ? t(`formFields:${props.name}`) : null,
        extra: msg.extra,
      });
    }

    return error.message;
  };

  return (
    <div className={inputClassNames}>
      {label && inputStyle && <span className="input__label">{label}</span>}
      {!textarea ? (
        <input {...restProps} ref={ref} />
      ) : (
        <textarea
          {...restProps}
          ref={ref}
          style={{ height: 120, paddingTop: 10 }}
        />
      )}
      {error && (
        <span className={'error-message'}>{getError()}</span>
      )}
    </div>
  );
});

export default Input;
